/**
 * TNK-132 — Bundle Settings moved to /settings/bundle-defaults
 * because it's global config for the bundle generator (strategies
 * enabled, profit vs speed bias, mystery-pack rarity mixes), not a
 * tool the operator reaches for daily. Thin redirect kept here for
 * bookmarks / muscle memory.
 */
import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/tools/bundle-settings")({
  component: BundleSettingsMovedRedirect,
});

function BundleSettingsMovedRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: "/settings/bundle-defaults", replace: true });
  }, [navigate]);
  return (
    <div className="mx-auto max-w-md py-12 text-center text-muted-foreground">
      <Loader2 size={20} className="mx-auto animate-spin" />
      <p className="mt-3 text-sm">Moved to Settings → Bundle Defaults…</p>
    </div>
  );
}
